<template>
  <div class="mt-5">
    <v-row id="order-switch-form">
      <v-col cols="12" md="12" class="mb-0 pb-0">
        <p>{{ descriptionTranslation }}</p>
      </v-col>
      <v-col cols="12" md="12" class="mt-0 pt-0">
        <PositionSearch
          ref="positionSearch"
          v-model="myOrder.switch.switchBuyPosition"
          :type="positionTypeToSwitch"
          :disabled="loading || editing || createNewSwitchBuyPosition"
        />
        <div class="order-modal-create-new-position mt-2">
          <a
            v-if="!editing"
            class="primary--text"
            @click="createNewSwitchBuyPosition = !createNewSwitchBuyPosition"
          >
            {{
              !createNewSwitchBuyPosition
                ? $t(`views.orders.orderModal.createNewPosition.activate`)
                : $t(`views.orders.orderModal.createNewPosition.deactivate`)
            }}
          </a>
        </div>
      </v-col>
    </v-row>
    <template v-if="createNewSwitchBuyPosition">
      <PositionForm
        :position.sync="myOrder.switch.switchBuyPosition"
        :loading="loading"
        :editing="editing"
        :positionTypesFilter="positionTypesFilter"
      />
    </template>

    <v-row>
      <v-col cols="12" md="12">
        <BrokerSearch v-model="myOrder.switch.switchBuyBroker" :disabled="loading" />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="12" class="mb-0 pb-0">
        <!-- <p class="mb-0">
          {{
            $t(`views.orders.orderModal.switch.switchBuyPositionNumber.${targetPositionType}.label`)
          }}
        </p> -->
      </v-col>
      <v-col cols="12" md="4" class="mt-2 pt-0">
        <div class="items-flex align-end">
          <CurrencyInput
            v-if="position.type === 'crypto' || position.type === 'cash'"
            v-model="myOrder.switch.switchBuyPositionNumber"
            :currency="
              (myOrder.switch.switchBuyPosition && myOrder.switch.switchBuyPosition.ticker) || null
            "
            :label="
              $t(
                `views.orders.orderModal.switch.switchBuyPositionNumber.${targetPositionType}.label`
              )
            "
            :disabled="loading"
          />
          <v-text-field
            v-else
            v-model="myOrder.switch.switchBuyPositionNumber"
            type="number"
            :label="
              $t(
                `views.orders.orderModal.switch.switchBuyPositionNumber.${targetPositionType}.label`
              )
            "
            :disabled="loading"
            hide-details
          />
          <span class="ml-2">
            <InfoIcon
              :size="17"
              :text="
                $t(
                  `views.orders.orderModal.switch.switchBuyPositionNumber.${targetPositionType}.info`
                )
              "
            />
          </span>
        </div>
      </v-col>

      <v-col cols="12" md="4" class="mt-2 pt-0">
        <ExchangeRateInput
          v-if="switchBuyExchangeRatePair"
          v-model="myOrder.switch.switchBuyExchangeRate"
          :exchangeRatePair="switchBuyExchangeRatePair"
          :disabled="loading"
          notAllowRotate
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { get } from 'lodash'
import { mapState } from 'vuex'
import PositionSearch from '@/views/components/common/PositionSearch'
import InfoIcon from '@/views/components/common/InfoIcon'
import PositionForm from '@/views/components/common/positions/PositionForm'
import CurrencyInput from '@/views/components/common/CurrencyInput'
import BrokerSearch from '@/views/components/common/BrokerSearch'
import ExchangeRateInput from '@/views/components/common/ExchangeRateInput'

const POSITION_FUND_SWITCH_TYPES = ['fund', 'plan']
const POSITION_CASH_CRYPTO_SWITCH_TYPES = ['cash', 'crypto']

export default {
  components: {
    PositionSearch,
    InfoIcon,
    PositionForm,
    CurrencyInput,
    BrokerSearch,
    ExchangeRateInput,
  },
  props: {
    myOrder: {
      type: Object,
      required: true,
    },
    position: {
      type: Object,
      required: true,
    },
    editing: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      createNewSwitchBuyPosition: false,
    }
  },
  computed: {
    ...mapState(['user']),
    positionTypeToSwitch() {
      if (POSITION_FUND_SWITCH_TYPES.indexOf(this.position.type) > -1)
        return POSITION_FUND_SWITCH_TYPES
      if (POSITION_CASH_CRYPTO_SWITCH_TYPES.indexOf(this.position.type) > -1)
        return POSITION_CASH_CRYPTO_SWITCH_TYPES
      return this.position.type // cash, crypto
    },
    descriptionTranslation() {
      if (POSITION_FUND_SWITCH_TYPES.indexOf(this.position.type) > -1)
        return this.$t(`views.orders.orderModal.switch.switchBuyPositionTitle.fund`)
      if (POSITION_CASH_CRYPTO_SWITCH_TYPES.indexOf(this.position.type) > -1)
        return this.$t(`views.orders.orderModal.switch.switchBuyPositionTitle.cash`)
      return this.$t(`views.orders.orderModal.switch.switchBuyPositionTitle.${this.position.type}`)
    },
    positionTypesFilter() {
      if (POSITION_FUND_SWITCH_TYPES.indexOf(this.position.type) > -1)
        return POSITION_FUND_SWITCH_TYPES
      if (POSITION_CASH_CRYPTO_SWITCH_TYPES.indexOf(this.position.type) > -1)
        return POSITION_CASH_CRYPTO_SWITCH_TYPES
      return [this.position.type]
    },
    targetPositionType() {
      return get(this.myOrder, 'switch.switchBuyPosition.type', this.position.type)
    },
    switchBuyExchangeRatePair() {
      const positionCurrency = get(this.position, 'currency', undefined)

      let switchBuyPositionCurrency
      if (this.editing) {
        switchBuyPositionCurrency = get(this.myOrder, 'switch.switchBuyPositionCurrency', undefined)
      } else {
        switchBuyPositionCurrency = get(
          this.myOrder,
          'switch.switchBuyPosition.currency',
          undefined
        )
      }

      // Tiene que ser diferente entre ambas posiciones (si es igual podemos usar el de la switch para la switchBuy)
      // y tiene que ser distinta de la base (si no es 1)
      const showSwitchBuyExchangeRate =
        positionCurrency !== switchBuyPositionCurrency &&
        switchBuyPositionCurrency !== this.user.baseCurrency
      if (switchBuyPositionCurrency && showSwitchBuyExchangeRate) {
        return `${switchBuyPositionCurrency}/${this.user.baseCurrency}`
      }

      return undefined
    },
  },
  watch: {
    async createNewSwitchBuyPosition() {
      if (this.createNewSwitchBuyPosition) {
        this.$set(this.myOrder.switch, 'switchBuyPosition', {})
      } else {
        this.$set(this.myOrder.switch, 'switchBuyPosition', null)
      }
    },
  },
}
</script>
